<template lang="html">
  <div class="w-60 vh-100 relative">
    <!-- Action bar -->
    <action-bar />

    <!-- Floor plan list -->
    <div class="center cf">
      <floorplan-list-tile v-if="!listMode" @click.native="closeFavorites()" v-for="(floorplan, index) in currentPlanList" :floorplan="floorplan" :index="index" :key="'plan-'+index"></floorplan-list-tile>
      <floorplan-list-table v-if="listMode"></floorplan-list-table>
    </div>

    <!-- No floorplan message -->
    <div class="b vh-50 flex flex-column items-center justify-center" v-show="currentPlanList.length === 0">
      <div>You do not have any saved floor plans.</div>
      <div class="dib link mt3 pointer interact-action" @click="TOGGLE_VIEWING_FAVOURITES()">
        Click here to select some
      </div>
    </div>

    <!-- Back to top -->
    <back-to-top></back-to-top>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BackToTopComponent from '@/components/BackToTop';
import FloorplanFavouritesActionBar from './FloorplanFavouritesActionBar';
import FloorplanListTileComponent from '../FloorplanList/FloorplanListTile';
import FloorplanListTableComponent from '../FloorplanList/FloorplanListTable';

export default {
  name: 'floorplan-favourites',
  components: {
    'action-bar': FloorplanFavouritesActionBar,
    'floorplan-list-tile': FloorplanListTileComponent,
    'floorplan-list-table': FloorplanListTableComponent,
    'back-to-top': BackToTopComponent
  },
  computed: {
    ...mapGetters(['activeFloorplans', 'favourites', 'favouritesMode', 'listMode']),
    currentPlanList() {
      return (this.favouritesMode) ? this.favourites : this.activeFloorplans;
    },
    savedPlans() {
      return true;
    }
  },
  methods: {
    ...mapActions(['TOGGLE_VIEWING_FAVOURITES']),
    closeFavorites() {
      this.TOGGLE_VIEWING_FAVOURITES();
    }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanFavourites/FloorplanFavourites.vue